<!-- 
    <select2>
    Select - multiple
-->
<template>
  <select :name="name" multiple class="form-control-sm" tabindex="-1">
      <!-- <i class="position-relative loading-spinner fas fa-spinner fa-pulse"></i> -->
      <slot></slot>
  </select>
</template>
<script>
import $ from 'jquery'
import language from '@/helpers/select2PtBr'
import axios from 'axios'
export default {
  name: 'select2-multiple',
  data(){
      return {
          formatedData: []
      }
  },
  props: ['name', 'options', 'value','text','id','url','urlExterna','hasUpdate'],
  methods:{
      formatData(dt){
          const self = this
          var AXIOS = null
          if(this.urlExterna){
              AXIOS = axios
          }else{
              AXIOS = this.axios
          }

          const format = function(data){
              self.formatedData = data.map(function (obj) {
                  if(obj) {
                      if(obj.id == 0){
                          obj.id = '0' // se o id for inteiro, altero para string(evitar bug no select2)
                      }else{
                          obj.id = obj.id || obj[self.id || self._id];
                      }

                      if(self.urlExterna){
                          obj.text = obj[self.text || 'nome']
                      }else{
                          obj.text = typeof obj.label == 'object' ? obj.label[self.text || 'nomeFantasia'] : obj.label
                      }
                      
                      if(obj.children){
                          self.formatData(obj.children)
                      }

                      return obj;
                  }
              });
          }
          

          if(!dt){
              AXIOS.get(self.url || self.urlExterna).then((dt) => {
                  format(dt.data)
              }).catch((err) => {
                  alert(err)
              })
          }else{
              if(dt.length){
                  format(dt)
              }
          }
          
      }
  },
  mounted: function () {
      var vm = this
      var AXIOS = null
      var count = 0
      if(this.urlExterna){
          AXIOS = axios
      }else{
          AXIOS = this.axios
      }
      
      if(vm.options.length > 0){ // caso exista data options formata e add para : 'this.formatedData'
          vm.formatData(vm.options)
      }

      vm.$select2 = $(vm.$el) //inicializa select2
      .select2({ 
          language: language,
          placeholder: 'Selecione...',
          width: '100%',
          allowClear: true,
          data: vm.formatedData
      })
      .val(vm.value)
      .trigger('change')
      .on('change', function () {
          vm.$emit('input', $(this).val())
      }).on('select2:open', function () { // no open verifico se existe um data
          if(vm.formatedData.length > 0){ // so fará o request caso 'vm.formatedData == vazio'
              return false
          }

          if(count <= 1){
              count++
              $(vm.$el).parent().append('<i class="position-relative loading-spinner fas fa-spinner fa-pulse"></i>')
              AXIOS.get(vm.url || vm.urlExterna) // request da lista e add valor para o formatedData
              .then(function(response){
                  vm.formatData(response.data)
                  $(vm.$el).empty().select2({ // recrio o select2 com uma nova data
                      language: language,
                      placeholder: 'Selecione...',
                      width: '100%',
                      allowClear: true,
                      delay: 100,
                      data: vm.formatedData,
                      matcher: (params, data) => {
                          // retorna data completo caso seja vazio
                          if ($.trim(params.term) === '') {
                              return data
                          }

                          // `data.children` contem os options atuais filtrados
                          if (data.children && data.children.length > 0) {
                              var filteredChildren = []
                              $.each(data.children, function (idx, child) {
                                  let tag = child.tags.length ? child.tags.join(',') : child.text

                                  if (tag.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
                                      filteredChildren.push(child)
                                  }
                              })

                              // retorna os grupos caso o texto tenha match com os childrens
                              if (filteredChildren.length) {
                                  let modifiedData = $.extend({}, data, true)
                                  modifiedData.children = filteredChildren

                                  return modifiedData
                              }
                          }

                          if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
                              let modifiedData = $.extend({}, data, true);

                              return modifiedData;
                          }

                          return null;
                      }
                  })
                  $(vm.$el).select2('open');
                  vm.$root.$emit(vm.name+'Options', vm.formatedData)

                  $(vm.$el).parent().find('.loading-spinner').remove()
              })
              .catch(function(){
                  return false
              });
          }
      })

      var scrollTop

     $(vm.$el).on("select2:selecting select2:unselecting", (event) => { // previne o bug primeiro item da lista
          if (event.params.args.originalEvent) {
              scrollTop = $(event.params.args.originalEvent.delegateTarget).prop('scrollTop')
          }
      }).on("select2:select select2:unselect", (event) => { // previne o bug primeiro item da lista
          if (event.params.originalEvent) {
              $(event.params.originalEvent.delegateTarget).prop('scrollTop', scrollTop)
          }
      }).on('select2:open', function() {
          let ulOptions = $("[id^=select2-"+vm.name+"][id$=-results]")
          
          ulOptions.on('click', function(event) { 
              /* 
                  Observo o clique na lista
                  E crio o multiselect por grupos | parent
              */
              event.stopPropagation()
              var data = $(event.target).html()
              var selectedOptionGroup = data.toString().trim()

              var groupchildren = []

              if(vm.formatedData && vm.formatedData.length && vm.formatedData[0] === undefined) {
                  // break caso não contenha resultado valido
                  return
              }

              for (var i = 0; i < vm.formatedData.length; i++) {
                  if (selectedOptionGroup.toString().trim() === vm.formatedData[i].text.toString().trim()) {
                      if(vm.formatedData[i].children){
                          for (var i2 = 0; i2 < vm.formatedData[i].children.length; i2++) {
                              groupchildren.push(vm.formatedData[i].children[i2].id)
                          }
                      }
                  }
              }

              var options = [];

              options = $(vm.$el).val();

              if (options === null || options === '') {
                  options = []
              }
              for (var idx = 0; idx < groupchildren.length; idx++) {
                  var count = 0
                  for (var j = 0; j < options.length; j++) {
                      if (options[j].toString() === groupchildren[idx].toString()) {
                          count++
                          break
                      }
                  }
                  if (count === 0) {
                      options.push(groupchildren[idx].toString())
                  }
              }

              $(vm.$el).val(options)
              $(vm.$el).trigger('change')
              if($(event.target).hasClass('select2-results__group')){
                  $(vm.$el).select2('close')  
              }
          })
      }).on('select2:close', function() { 
          $('.modal-body').off('scroll')
      });
  },
  watch: {
      value: {
          handler(val) {
              if ([...val].sort().join(",") !== [...$(this.$el).val()].sort().join(",")){
                  $(this.$el).val(val).trigger('change')
              }
          },
          deep: true
      },
      options: function (options) {
          if(!this.hasUpdate){
              if(this.formatedData.length > 0){
                  return false
              }
              
              this.formatData(options)
              
              // update options
              this.$select2.empty().select2({ 
                  language: language,
                  placeholder: 'Selecione...',
                  width: '100%',
                  delay: 100,
                  allowClear: true,
                  data: this.formatedData 
              })
              return false
          }

          //Inicia loading do multiselect
          //$(vm.$el).append('<i class="loading-spinner fas fa-spinner fa-pulse"></i>')
          this.formatData(options)
          const opt = { 
              language: language,
              placeholder: 'Selecione...',
              width: '100%',
              data: this.formatedData,
              allowClear: true
          }

          this.$select2.empty().select2(opt)
      }
  },
  destroyed: function () {
      $(this.$el).off().select2('destroy')
  }
}
</script>
<style>
  li.select2-results__option strong.select2-results__group:hover {
      background-color: #ddd;
      cursor: pointer;
  }
</style>
